export interface observationList {
  testing_phase?: string;
  platform?: string;
  screenName?: string;
  issueType?: string;
  reportedBy?: string;
  assignedto?: string;
  description?: string;
  status?: string;
}

// export interface QaObservationTypes {

// }

// export interface qaObservationDetail {
//   project_id: string,
//   testing_phase: string,
//   account_used: string,
//   platform: string,
//   module_name: string,
//   screen_name: string,
//   issue_category: string,
//   issue_type: string,
//   reported_by: string,
//   assigned_to: string,
//   targetDate: string,
//   comment: string,
//   supportingDocument: File | Blob,
//   observation_id?: string,
//   status: string,
//   createdDate: string,
//   dev_comments?: string
// }

export interface SearchObservationForm {
  keyword?: string;
  project_id?: string;
  reported_by?: string;
  assigned_to?: string;
  issue_type?: string;
}

// export interface ObservationListDetail {
//   project_id: string,
//   testing_phase: string,
//   account_used: string,
//   platform: string,
//   module_name: string,
//   screen_name: string,
//   issue_category: string,
//   issue_type: string,
//   reported_by: string,
//   reported_by_name: string,
//   assigned_to: string,
//   targetDate: string,
//   comment: string,
//   supportingDocument: File | Blob,
//   observation_id?: string,
//   status: string,
//   status_name: string,
//   createdDate: string,
//   dev_comments?: string,
// }

export interface ObservationListDetail {
  observation_id?: string;
  customer_id: string;
  user_id: string;
  project_id: string;
  testing_phase_id: string;
  testing_phase: string;
  account_used: string;
  platform_id: string;
  platform: string;
  module_name: string;
  screen_name: string;
  issue_category_id: string;
  issue_category?: string;
  issue_type_id: string;
  issue_type: string;
  reported_by: string;
  assigned_to: string;
  createdDate: string;
  targetDate: string;
  comment: string;
  supportingDocument: File | Blob,
  status: string;
  status_name: string;
  assigned_to_name: string;
  reported_by_name: string;
  pr_name: string;
  IssueCategory_name: string;
  dev_comments?: string[];
  dev_supporting_documents: string[];
  reassign_history?: any[]
}


export interface observationTypeList {
  qa_IssueType_id?: string,
  issuetype_name?: string,
  active_status?: string
}

export interface createObservation {
  project_id: string,
  testing_phase: string,
  account_used: string,
  platform: string,
  module_name: string,
  screen_name: string,
  issue_category: string,
  issue_type: string,
  reported_by: string,
  assigned_to: string,
  targetDate: string,
  comment: string,
  supportingDocument: File | Blob,
  status: string,
  createdDate: string,
  observation_id?: string,
  dev_comments?: string
}

export interface updateObservation {
  dev_comments: string,
  status: string
}

export interface testPhases {
  qa_testing_ph_id?: string,
  testing_phase: string,
  active_status?: string
}